<template>
	<div
			class="grey lighten-4 mx-auto pa-4 rounded-xl preview-frame"
			:class="{ 
				'preview-frame--has-preview': hasPreview,
				'ma-n4 ma-md-n8 rounded-b-0': inModal
			}"
			:style="{
				height: !inModal
						? '100%'
						: hasPreview && $vuetify.breakpoint.mdAndUp 
								? 'calc(100% + 4rem)' 
								: 'calc(100% + 2rem)'
			}"
	>
		<div
				class="d-flex elevation-4 flex-column h-100 preview-frame"
				style="border-radius: 1rem;"
		>
			<div class="flex-grow-1 position-relative">
				<iframe
						v-show="previewUrl && !iframeLoading"
						ref="iframeRef"
						@load="iframeLoaded"
						:src="previewUrl"
						style="height: 100%; width: 100%;"
				></iframe>
				<div
						class="align-center d-flex justify-center loader position-absolute white"
						:class="{ 'loader--hide': previewUrl && !iframeLoading }"
						style="height: 100%; left: 0; top: 0; width: 100%;"
				>
					<div
							class="align-center d-flex flex-column"
							style="width: calc(100% - 4rem);"
					>
						<v-progress-linear
								v-if="previewUrl"
								class="w-100"
								color="secondary"
								height="2"
								indeterminate
						></v-progress-linear>
						<div class="font-weight-bold mt-2 text-body-2">{{ loadingMessage }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'MobilePassPreview',
	props: {
		inModal: Boolean,
		loadingMessage: {
			type: String,
			default: 'Loading Content'
		},
		previewUrl: {
			type: [Boolean, String],
			default: false
		}
	},
	data() {
		return {
			iframeLoading: true
		};
	},
	computed: {
		hasPreview() {
			return !!this.previewUrl && !this.iframeLoading;
		}
	},
	methods: {
		iframeLoaded() {
			const checkIframeReadyState = () => {
				const iframeDoc = this.$refs.iframeRef.contentDocument || this.$refs.iframeRef.contentWindow.document;
				if(iframeDoc.readyState === "complete" || iframeDoc.readyState === "interactive") {
					this.iframeLoading = false;
					this.$forceUpdate();
				}
				else {
					setTimeout(checkIframeReadyState, 100); // Check every 50ms
				}
			};
			checkIframeReadyState();
		}
	},
	watch: {
		previewUrl: {
			immediate: true,
			handler() {
				this.iframeLoading = true;
			}
		}
	}
}
</script>

<style lang="scss" scoped>
::v-deep div,
::v-deep iframe {
	border: none;
	border-radius: 1rem !important;
}

.preview-frame {
	height: 30%;
	transition: height 0.5s ease-in-out;
}

::v-deep .loader {
	opacity: 1;
	pointer-events: none;
	transition: opacity 1s ease-in-out;

	&--hide {
		opacity: 0;
	}
}
</style>
